import * as yup from "yup";

export const userPanelFormSchema = (isCompany) => {
  return yup.object().shape({
    status: yup.mixed().required("Status is required"),
    emailAddress: yup.string().email("Invalid email").required("Email is required"),
    employeeType: isCompany ? yup.mixed() : yup.mixed().required("Employee Type is required"),
  });
};
